import isIE from './isIE';

function getSize(axis, body, html, computedstyle) {
  return Math.max(
    body[`offset${axis}`],
    body[`scroll${axis}`],
    html[`client${axis}`],
    html[`offset${axis}`],
    html[`scroll${axis}`],
    isIE(10)
      ? html[`offset${axis}`] +
        computedstyle[`margin${axis === 'Height' ? 'Top' : 'Left'}`] +
        computedstyle[`margin${axis === 'Height' ? 'Bottom' : 'Right'}`]
      : 0
  );
}

export default function getWindowSizes() {
  const body = document.body;
  const html = document.documentElement;
  const computedstyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedstyle),
    width: getSize('Width', body, html, computedstyle),
  };
}
